import { useNavigate } from "react-router-dom";
import DetailRow from "../../../components/UI/viewDialogs/DetailRow";
import Modal from "../../../components/portal/Modal";
import GradientButton from "../../../components/UI/buttonUI/GradientButton";
import successIcon from "../../../assets/icons/successIcon.svg";

export default function SiteOperatorDialog({
  viewDetails,
  stationName,
  stationId,
}) {
  const navigate = useNavigate();
  return (
    <Modal modalWidth="view-dialog-content max-w-2xl">
      <img src={successIcon} alt="messageIcon" className="mx-auto mb-1 w-9" />
      <p className="view-success-msg-d ">Operator Successfully Added!</p>
      <div className={`px-2 overflow-auto`}>
        <div className="view-dialog-content-wrap">
          <DetailRow title="Site Name" value={stationName} />
          <DetailRow title="Site Id" value={stationId} />
          <DetailRow title="Operator Name" value={viewDetails.name} />
          <DetailRow
            title="Operator Phone"
            value={viewDetails.mobile}
            last="border-b-0"
          />
        </div>
      </div>
      <div className="pt-5 text-center">
        <GradientButton
          btnText="Ok"
          width="w-28"
          onClick={() => navigate("/site/all")}
        />
      </div>
    </Modal>
  );
}
